import React, { useEffect, useState } from 'react';
import { CATS } from '../components/nieuws/nieuwsUtil';

const API = process.env.REACT_APP_API_URL || '/api';
const ROTATIE_MS = 20000;

export default function NieuwsLive() {
  const token = new URLSearchParams(window.location.search).get('token') || '';
  const [data, setData] = useState(null);
  const [fout, setFout] = useState('');
  const [i, setI] = useState(0);
  const [klok, setKlok] = useState(new Date());

  const laden = () => fetch(`${API}/nieuws/live?token=${encodeURIComponent(token)}`).then(async (r) => { if (!r.ok) throw new Error((await r.json()).message || r.status); return r.json(); }).then(setData).catch((e) => setFout(String(e.message)));
  useEffect(() => { laden(); const t = setInterval(laden, 5 * 60 * 1000); return () => clearInterval(t); }, []); // eslint-disable-line
  useEffect(() => { const t = setInterval(() => setKlok(new Date()), 1000); return () => clearInterval(t); }, []);
  useEffect(() => { if (!data?.items?.length) return; const t = setInterval(() => setI((x) => (x + 1) % data.items.length), ROTATIE_MS); return () => clearInterval(t); }, [data]);

  const n = data?.items?.[i];
  const cat = n ? (CATS[n.categorie] || CATS.nieuws) : null;
  const S = { root: { position: 'fixed', inset: 0, background: '#0f172a', color: '#fff', fontFamily: 'system-ui, sans-serif', display: 'flex', flexDirection: 'column', overflow: 'hidden' } };

  if (fout) return <div style={{ ...S.root, alignItems: 'center', justifyContent: 'center', fontSize: 24, color: '#94a3b8' }}>Nieuws-scherm: {fout}</div>;
  if (!data) return <div style={{ ...S.root, alignItems: 'center', justifyContent: 'center', fontSize: 24, color: '#94a3b8' }}>Laden…</div>;

  return (
    <div style={S.root}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '22px 44px' }}>
        <div style={{ fontSize: 30, fontWeight: 800 }}>WOM<span style={{ color: '#00D4AA' }}>sys</span> <span style={{ fontWeight: 400, color: '#94a3b8', fontSize: 22, marginLeft: 10 }}>{data.bedrijf}</span></div>
        <div style={{ textAlign: 'right' }}>
          <div style={{ fontSize: 44, fontWeight: 700, lineHeight: 1 }}>{klok.toLocaleTimeString('nl-NL', { hour: '2-digit', minute: '2-digit' })}</div>
          <div style={{ color: '#94a3b8', fontSize: 16, textTransform: 'capitalize' }}>{klok.toLocaleDateString('nl-NL', { weekday: 'long', day: 'numeric', month: 'long' })}</div>
        </div>
      </div>

      {!n ? <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#94a3b8', fontSize: 28 }}>Nog geen berichten</div> : (
        <div key={n.id} style={{ flex: 1, display: 'grid', gridTemplateColumns: '1.1fr 1fr', gap: 44, padding: '0 44px', animation: 'nlfade .6s ease' }}>
          <div style={{ borderRadius: 24, overflow: 'hidden', background: n.afbeelding_url ? `url(${n.afbeelding_url}) center/cover` : `linear-gradient(135deg, ${cat.bg}, #1e293b)`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 160 }}>{!n.afbeelding_url && cat.emoji}</div>
          <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
            <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
              <span style={{ background: cat.bg, color: cat.fg, fontSize: 14, fontWeight: 800, letterSpacing: 1.5, textTransform: 'uppercase', padding: '6px 14px', borderRadius: 20 }}>{cat.label}</span>
              <span style={{ color: '#94a3b8', fontSize: 16 }}>{n.bedrijf_id ? n.bedrijf_naam : 'WOMsys'} · {new Date(n.publicatie_datum).toLocaleDateString('nl-NL', { day: 'numeric', month: 'long' })}</span>
            </div>
            <h1 style={{ fontSize: 52, lineHeight: 1.1, margin: '22px 0 18px', letterSpacing: -0.5 }}>{n.titel}</h1>
            <p style={{ fontSize: 24, lineHeight: 1.5, color: '#cbd5e1', margin: 0 }}>{n.intro}</p>
            <div style={{ display: 'flex', gap: 8, marginTop: 34 }}>{data.items.map((_, k) => <span key={k} style={{ width: k === i ? 34 : 10, height: 10, borderRadius: 5, background: k === i ? '#00D4AA' : '#334155', transition: 'width .3s' }} />)}</div>
          </div>
        </div>
      )}

      {data.ticker?.length > 0 && (
        <div style={{ background: '#1e293b', padding: '14px 0', marginTop: 28, overflow: 'hidden', whiteSpace: 'nowrap', fontSize: 18, color: '#cbd5e1' }}>
          <div style={{ display: 'inline-block', animation: `nlticker ${Math.max(30, data.ticker.length * 8)}s linear infinite` }}>
            {[...data.ticker, ...data.ticker].map((t, k) => <span key={k} style={{ marginRight: 60 }}><span style={{ color: '#00D4AA', marginRight: 10 }}>✦</span>{t.titel}</span>)}
          </div>
        </div>
      )}
      <style>{`@keyframes nlfade{from{opacity:0;transform:translateY(8px)}to{opacity:1;transform:none}} @keyframes nlticker{from{transform:translateX(0)}to{transform:translateX(-50%)}}`}</style>
    </div>
  );
}
